export default __webpack_public_path__ + "static/laminas_6-71ed6e57575cd264bc6b8c5b1b8a8554.png";